module.exports = __webpack_public_path__ + "static/media/fye.2241ae8f.png";